@if(flecxModalService.isOpen){
<div class="container">
  <div class="modal__overlay"></div>
  <div class="modal__content">
    <!-- <button class="modal__close">✖</button> -->
    <i class="fa-duotone fa-circle-info"></i>
    <div class="modal__text" [innerHTML]="flecxModalService.text">
    </div>
    
    <div class="modal__buttons">
      @if(flecxModalService.isSingleButton){
        <button class="single-button--with-bg" (click)="flecxModalService.onAction(flecxModalService.fButtonText)">{{flecxModalService.fButtonText}}</button>
      }
      @else if(flecxModalService.isDoubbleButton){
        <button class="single-button--with-bg" (click)="flecxModalService.onAction(flecxModalService.fButtonType)">{{flecxModalService.fButtonText}}</button>
        <button class="single-button--with-bg" (click)="flecxModalService.onAction(flecxModalService.sButtonType)">{{flecxModalService.sButtonText}}</button>
      }
    </div>
   
  </div>
</div>
}